<app-modal-basic
  #modal
  [dialogClass]="'modal-screen'"
  (closed)="fechar()"
  modalContentId="modalGerarMensalidades"
>
  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="icofont icofont-calendar"></i> Geração de mensalidades através de
      contratos
    </h4>
    <button type="button" class="close basic-close" (click)="fechar()">
      <span class="btn-close" aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="app-modal-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-12">
          <h6>Filtro</h6>
        </div>
        <div class="form-group col-sm-6">
          <label for="form_numeroDe">Número do Contrato</label>
          <div class="input-group">
            <input
              id="form_numeroDe"
              type="text"
              class="form-control"
              formControlName="numeroDe"
              appOnlyNumbers
            />
            <span class="input-group-addon">até</span>
            <input
              id="form_numeroAte"
              type="text"
              class="form-control"
              formControlName="numeroAte"
              appOnlyNumbers
            />
          </div>
        </div>
        <div class="form-group col-sm-2">
          <label for="form_diaFaturamento">Dia Faturamento</label>
          <input
            id="form_diaFaturamento"
            type="number"
            class="form-control"
            formControlName="diaFaturamento"
            appOnlyNumbers
            (change)="onDiaFaturamentoChange($event)"
          />
        </div>
        <div
          class="form-group col-sm-4"
          rem5
          combobox
          [type]="'cliente'"
          [loading]="loading"
          [form]="form"
          formControlName="clienteId"
          appendTo="#modalGerarMensalidades"
        ></div>
      </div>

      <div class="row">
        <div class="col-12">
          <h6>Informações para Gerar Mensalidade</h6>
        </div>
        <div class="form-group col-sm-6 col-md-3">
          <label class="label-required" for="form_mesReferenciaCobranca">Mês referência da Cobrança</label>
          <ng-select
            id="form_mesReferenciaCobranca"
            [items]="meses"
            bindLabel="nome"
            bindValue="id"
            formControlName="mesReferenciaCobranca"
            placeholder="Selecione"
            appendTo="#modalGerarMensalidades"
          ></ng-select>
          <show-errors [control]="form.controls['mesReferenciaCobranca']"></show-errors>
        </div>
        <div class="form-group col-sm-6 col-md-3">
          <label class="label-required" for="form_mesReferenciaServico">Mês referência do Serviço</label>
          <ng-select
            id="form_mesReferenciaServico"
            [items]="meses"
            bindLabel="nome"
            bindValue="id"
            formControlName="mesReferenciaServico"
            placeholder="Selecione"
            appendTo="#modalGerarMensalidades"
          ></ng-select>
          <show-errors [control]="form.controls['mesReferenciaServico']"></show-errors>
        </div>
        <div class="form-group col-sm-6 col-md-2">
          <label class="label-required" for="form_anoReferenciaServico">Ano</label>
          <input
            id="form_anoReferenciaServico"
            type="number"
            class="form-control"
            formControlName="anoReferenciaServico"
            appOnlyNumbers
          />
          <show-errors [control]="form.controls['anoReferenciaServico']"></show-errors>
        </div>
        <div
          class="form-group col-sm-12 col-md-4"
          rem5
          combobox
          [type]="'condicao-pagamento'"
          [loading]="loading"
          [form]="form"
          formControlName="condicaoPagamentoId"
          appendTo="#modalGerarMensalidades"
        ></div>

        <div class="form-group col-sm-12">
          <button
            type="button"
            class="btn btn-primary"
            (click)="pesquisar()"
            [disabled]="loading.request"
          >
            <app-loading
              [loading]="loading.request"
              icone="icofont icofont-search"
            ></app-loading>
          </button>
        </div>
      </div>

      <div *ngIf="items.length > 0" class="row">
        <div class="col-12">
          <hr class="mt-0" />
        </div>
        <div class="col-12">
          <div class="dt-responsive">
            <div class="table-responsive">
              <app-dim-datatable
                [loading]="loading.table"
                [columns]="columns"
                [data]="items"
                [rowsOnPage]="searchData.pageSize"
                [totalItems]="searchData.totalItems"
                [currentPage]="searchData.pageIndex"
                [selectable]="true"
                [multiple]="true"
                [selecionados]="selecionados"
                (sorting)="setOrdenation($event)"
                (pageChanged)="setPagination($event)"
              >
                <ng-template
                  #customTmpl
                  let-column="column"
                  let-row="row"
                  style="width: 1px"
                >
                  <ng-template [ngIf]="column === 'preview'">
                    <div class="d-grid place-items-center">
                      <button
                        type="button"
                        class="btn btn-info btn-mini waves-effect waves-light"
                        style="border-radius: 10%"
                        (click)="handleOnPreview(row)"
                        [disabled]="loading.preview"
                        ngbTooltip="Pré-visualizar"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                    </div>
                  </ng-template>
                </ng-template>
              </app-dim-datatable>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="app-modal-footer w-100">
    <div class="col-12 d-flex justify-content-end align-items-center">
      <div class="mr-3">
        <strong>Valor total da grade:</strong>
        {{ valorTotalGrade | currency : 'BRL' : 'symbol' : '1.2-2' }}
      </div>
      <div class="mr-3">
        <strong>Valor total selecionado:</strong>
        {{ valorTotalSelecionado | currency : 'BRL' : 'symbol' : '1.2-2' }}
      </div>
      <button
        type="button"
        class="btn btn-primary"
        (click)="handleOnGerar()"
        [disabled]="loading.gerar || selecionados.length === 0"
      >
        <app-loading
          [loading]="loading.gerar"
          icone="fa fa-check"
          texto="Gerar Mensalidades"
          textoLoading="Gerando"
        ></app-loading>
      </button>
      <button type="button" class="btn btn-outline-warning ml-2" (click)="fechar()">
        Cancelar
      </button>
    </div>
  </div>
</app-modal-basic>
